import { Component, OnInit } from '@angular/core';
import { ReportData } from 'src/shared/models/report-data.model';
import { Subject } from 'rxjs';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';
import { ReportDataSet } from 'src/shared/models/report-dataset.model';
import { ShowReport } from 'src/shared/enum/show-report.enum';
import { Constants } from 'src/shared/utilities/constants.util';
import { ReportService } from 'src/shared/services/report.service';
import { ReportConstants } from '../../shared/report-constants.util';

@Component({
  selector: 'total-uos-measures-page',
  templateUrl: './total-uos-measures-page.component.html',
  styleUrls: ['./total-uos-measures-page.component.scss']
})
export class TotalUosMeasuresPageComponent implements OnInit {
  staffingData: ReportData;
  showReport: ShowReport = ShowReport.Total;
  toggleReportEventsSubject: Subject<void> = new Subject<void>();
  filterEventsSubject: Subject<void> = new Subject<void>();
  filters: ReportFilters;
  views:string[];
  defaultView:string;
  gridData: ReportDataSet[];

  constructor(private reportService: ReportService){
  }

  ngOnInit() {
    this.filters = new ReportFilters();
    this.staffingData = new ReportData();
    this.gridData = [];
    this.views = [ 
        ReportConstants.DateViewLabel, 
        ReportConstants.DayOfWeekViewLabel, 
        ReportConstants.PeriodEndViewLabel, 
        ReportConstants.ShiftBlockViewLabel, 
        ReportConstants.WeekViewLabel
    ];
    this.defaultView = ReportConstants.DateViewLabel;
    this.reportService.announceSummarySelected(Constants.TotalUosSummary);
  }

  staffingDataUpdated(reportData: any){
    this.staffingData = reportData;
    this.gridData = MiscUtil.getDataFilteredByDataSetName(reportData, this.showReport);
  }

  filterUpdated(filters:ReportFilters){
    this.filters = filters;
    this.filterEventsSubject.next();
  }

  toggleReportDisplayed(): void {
    this.showReport = (this.showReport == ShowReport.Total) ? ShowReport.Average : ShowReport.Total;
    this.toggleReportEventsSubject.next();
    this.staffingDataUpdated(this.staffingData);
  }
}
